export function createRoutes() {
  return [
    {
      path: 'episodes',
      component: () => import(/* webpackChunkName: "EpisodeChrome" */ './EpisodeChrome.vue'),
      children: [
        {
          path: '/',
          name: 'episodeList',
          component: () => import(/* webpackChunkName: "EpisodeList" */ './EpisodeList.vue'),
        },
        {
          path: 'import',
          components: {
            default: () => import(/* webpackChunkName: "EpisodeList" */ './EpisodeList.vue'),
            dialog: () => import(/* webpackChunkName: "ImportEpisodeContentModal" */ './ImportEpisodeContentModal.vue'),
          },
        },
        {
          path: 'create',
          name: 'EpisodeAdd',
          component: () => import(/* webpackChunkName: "EpisodeAdd" */ './EpisodeAdd.vue'),
        },
        {
          path: ':episodeId',
          name: 'EpisodeEdit',
          component: () => import(/* webpackChunkName: "EpisodeEditChrome" */ './EpisodeEdit.vue'),
        },
      ],
    },
  ];
}

export default {
  createRoutes,
};
